import React from 'react';
import PropTypes from 'prop-types';
import loadingIcon from './loading-icon.svg';



export default function Loading({ style }) {
  return (
    <img src={loadingIcon} style={style} alt="Loading..." />
  );
}

Loading.propTypes = {
  style: PropTypes.shape(),
};

Loading.defaultProps = {
  style: {},
};

